const _ = require('lodash')
const paramsRegex = /{{\d+}}/g
class RenderTemplate {
  constructor(template) {
    this.template = template
    this.elements = {}
    this.getElements()
    this.components = this.render()
    Object.freeze(this)
  }

  getElements() {
    if (_.isEmpty(this.template)) return
    this.elements = this.template.components.reduce((acc, component) => {
      acc[component.type] = component
      return acc
    }, {})
  }

  renderBody() {
    try {
      const { name, category, language } = this.template
      const body = this.elements.BODY ? this.elements.BODY.text : ''
      return {
        name,
        category,
        language,
        body
      }
    } catch (e) {
      console.log('Render body error', this.template)
    }
  }

  renderHeader() {
    const { HEADER } = this.elements
    const defaultResponse = {
      format: '',
      text: ''
    }
    if (!HEADER) return defaultResponse
    const { format, example = {}, text: headerText = false } = HEADER
    if (_.isEmpty(example) && !headerText) return defaultResponse
    const text = example.header_handle
      ? example.header_handle[0]
      : headerText || ''

    return {
      format,
      text
    }
  }

  renderFooter() {
    const { FOOTER } = this.elements
    if (!FOOTER) return ''
    return FOOTER.text
  }

  renderButtons() {
    const { BUTTONS } = this.elements
    if (!BUTTONS) return []
    return BUTTONS.buttons.map((button) => {
      return {
        text: button.text,
        type: button.type,
        url: button.url
      }
    })
  }

  render() {
    return {
      body: this.renderBody(),
      header: this.renderHeader(),
      buttons: this.renderButtons()
    }
  }

  headerHasMedia() {
    const media = ['IMAGE', 'VIDEO', 'DOCUMENT']
    if (this.elements.header) this.elements.HEADER = this.elements.header
    return this.elements.HEADER && media.includes(this.elements.HEADER.format)
  }

  headerMediaType() {
    if (!this.headerHasMedia()) return ''
    if (this.elements.header) this.elements.HEADER = this.elements.header
    return this.elements.HEADER.format.toLowerCase() + '/*'
  }

  needsParameters() {
    return (
      Object.values(this.elements).some((element) => {
        return paramsRegex.test(element.text)
      }) ||
      this.headerHasMedia() ||
      this.buttonHasParams()
    )
  }

  buttonHasParams() {
    const buttons = this.renderButtons()
    if (!buttons.length) return false
    return buttons.some((el) => paramsRegex.test(el.url))
  }

  parameters() {
    const params = Object.entries(this.elements)
      .map(([from, data]) => {
        const { text, format } = data
        const params = new Set((text || '').match(paramsRegex) || []).size
        if (params <= 0) return false
        return {
          from,
          params,
          format
        }
      })
      .filter(Boolean)
    if (this.headerHasMedia()) {
      params.push({ from: 'HEADER', params: 1, type: this.headerMediaType() })
    }
    if (this.buttonHasParams()) {
      const buttons = this.renderButtons()
      const urlButton = buttons.find((el) => el.type === 'URL')
      if(!urlButton.url.includes('COPY_CODE')) {
        params.push({
          from: 'BUTTONS',
          params: 1,
          format: 'TEXT',
          description: decodeURI(urlButton.url)
        })
      }
    }

    return params
  }

  static defaultData() {
    const template = new RenderTemplate({})
    return {
      header: template.renderHeader(),
      header_example_text: '',
      header_example_file: null,
      message_template: template.renderBody(),
      buttons: template.renderButtons(),
      footer: template.renderFooter(),
      body_example: []
    }
  }

  static defaultView(data) {
    const defaultData = RenderTemplate.defaultData()
    const keysToEdit = Object.keys(defaultData)
    keysToEdit.forEach((key) => {
      data[key] = defaultData[key]
    })
  }
}

class TemplateEditor {
  constructor(template) {
    this.templateOriginal = template
    this.template = _.cloneDeep(template)
    this.elements = {}
    this.elementTarget = {
      BODY: 'message_template',
      HEADER: 'header',
      FOOTER: 'footer'
    }
    this.childElements = {
      BODY: 'body',
      HEADER: 'text',
      FOOTER: 'text'
    }
    this.params = {}
  }

  static create(template) {
    const editor = new TemplateEditor(template)
    return Object.freeze(editor)
  }

  headerFormat() {
    return this.templateOriginal.header.format
  }

  editElement({ element, position, data } = {}) {
    if (element === 'HEADER' && this.headerFormat() !== 'TEXT') return
    const elementKey = this.elementTarget[element]
    const elementTarget = this.template[elementKey]
    const child = this.childElements[element]
    if (!this.params[element]) this.params[element] = {}
    if (!this.params[element][position]) this.params[element][position] = {}
    this.params[element][position] = data
    let textTemplate = elementTarget ? elementTarget[child] : ''
    Object.entries(this.params[element]).forEach(([position, value]) => {
      textTemplate = textTemplate.replaceAll(`{{${position}}}`, value)
    })
    this.templateOriginal[elementKey][child] = textTemplate
  }

  static getInputs(elements) {
    const elementsArray = Array.from(elements)
    return elementsArray.filter(filterInputs)
  }

  static inputsMissing(inputs) {
    if (_.isEmpty(inputs)) return true
    const inputsArray = TemplateEditor.getInputs(inputs)
    return inputsArray.some((input) => !input.value)
  }
}
const filterInputs = (e) => e.tagName === 'INPUT'
const parseInput = (input) => {
  return {
    from: input.id.split('_')[0],
    type: input.type,
    data: input.value,
    accept: input.accept || null,
    input
  }
}
const parseParams = (params) => {
  return Object.entries(params).reduce((acc, [key, value]) => {
    const name = key.split('-')[0]
    if (!acc[name]) acc[name] = []
    acc[name].push(value)
    return acc
  }, {})
}
module.exports = {
  RenderTemplate,
  TemplateEditor,
  filterInputs,
  parseInput,
  parseParams
}
